<template>
  <div>
    <MasterSingleSalary></MasterSingleSalary>
    <MasterGroupClassSalary
      :masterUserIdFilter="masterUserId"
    ></MasterGroupClassSalary>
    <!-- <MasterHomeworkSalary></MasterHomeworkSalary> -->
  </div>
</template>

<script>
export default {
  components: {
    MasterSingleSalary,
    MasterGroupClassSalary,
    // MasterHomeworkSalary,
  },
  computed: {
    masterUserId() {
      if (getUserData) {
        return getUserData().user.userId;
      }
    },
  },
};
import MasterSingleSalary from "@/views/components/Salary/MasterSingleSalary.vue";
import MasterGroupClassSalary from "@/views/components/Salary/MasterGroupClassSalary.vue";
// import MasterHomeworkSalary from "@/views/components/Salary/MasterHomeworkSalary.vue";
import { getUserData } from "@/auth/utils";
</script>
